<div class="clock-notch">
  <span>{{ getTime() }}</span>
</div>

<div class="header-marquee-strip" *ngIf="marqueeItems().length > 0">
    <div class="marquee-content-wrapper marquee-animation">
        <ng-container *ngFor="let item of marqueeItems(); let last = last">
            <!-- Notice Item -->
            <div class="marquee-item notice" *ngIf="item.type === 'notice'" (click)="openNoticeDetails(item)">
                <span class="badge badge-info">{{ 'NOTICE' | translate }}</span>
                <span class="message">{{ item.title }}</span>
            </div>

            <!-- Bible Verse Item -->
            <div class="marquee-item bible-verse" *ngIf="item.type === 'bible'">
                <i class="pi pi-bookmark-fill mr-1 text-warning"></i>
                <span class="message">"{{ item.text }}" - {{ item.reference }}</span>
            </div>

            <div class="marquee-divider" *ngIf="!last">|</div>
        </ng-container>
    </div>
</div>

<div class="dev-ribbon" *ngIf="isDev">DEV</div>

<nav class="navbar navbar-expand-lg top-navbar">
  <div class="container-fluid d-flex align-items-center justify-content-between">
    
    <div class="navbar-left d-flex align-items-center header-left-wrap">
      <div class="logodiv mr-3 flex-shrink-0">
        <a [routerLink]="['/dashboard']" class="d-flex align-items-center text-decoration-none">
          <img [src]="logo()" alt="Logo" class="img-fluid" />
        </a>
      </div>
      <ul class="nav navbar-nav horizontal-nav">
        <li
          class="nav-item dropdown"
          *ngFor="let m of menu(); trackBy: trackByTitle"
          [class.show]="activeSubmenu() === m.title"
        >
          <a
            *ngIf="m?.children"
            href="javascript:void(0);"
            class="nav-link dropdown-toggle icon-menu"
            [class.active]="activeSubmenu() === m.title"
            (click)="toggleSubmenu($event, m.title)"
          >
            <span>{{ m?.title | translate }}</span>
            <i class="pi pi-chevron-down ml-1" style="font-size: 0.7rem; opacity: 0.7;"></i>
          </a>

          <a
            *ngIf="!m?.children"
            class="nav-link icon-menu"
            [routerLink]="[m.urlString]"
            routerLinkActive="active"
            [queryParams]="m?.queryparam"
            [routerLinkActiveOptions]="{exact: true}"
            (click)="closeSubmenu()"
          >
            <span>{{ m?.title | translate }}</span>
          </a>

          <div 
            class="dropdown-menu vivify flipInY p-0" 
            *ngIf="m?.children"
            [class.show]="activeSubmenu() === m.title"
          >
            <div class="submenu-container">
              <a
                *ngFor="let item of m.children; trackBy: trackByTitle"
                class="dropdown-item pt-2 pb-2"
                [attr.title]="item?.title"
                [routerLink]="[transformUrl(item).urlString]"
                [queryParams]="item?.queryparam"
                routerLinkActive="active"
                (click)="closeSubmenu()"
              >
                {{ item?.title | translate }}
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="navbar-right d-flex align-items-center">
      <ul class="nav navbar-nav horizontal-nav align-items-center">
        <li>
          <a
            href="javascript:void(0);"
            (click)="openAi()"
            class="icon-menu mr-3 ai-chat-icon"
            title="Chat AI"
          >
            <i class="pi pi-prime"></i>
          </a>
        </li>
        <li class="nav-item dropdown user-profile-item" [class.show]="activeSubmenu() === 'PROFILE'">
          <a
            href="javascript:void(0);"
            class="user-account dropdown-toggle"
            (click)="toggleSubmenu($event, 'PROFILE')"
          >
            <div class="user_div">
              <img
                [src]="logo()"
                class="user-photo"
                alt="UserProfile"
              />
            </div>
            <div class="user-name ml-2 d-none d-md-block">
              <strong>{{ user()?.fname }} {{ user()?.lname }}</strong>
              <small class="d-block text-muted">{{ roleName() }}</small>
            </div>
          </a>
          
          <ul class="dropdown-menu dropdown-menu-right account vivify flipInY" [class.show]="activeSubmenu() === 'PROFILE'" role="menu">
            <!-- Profile Info Section -->
            <li class="profile-header p-3 border-bottom">
              <div class="d-flex align-items-center">
                <div class="user_div_mini mr-3">
                  <img [src]="logo()" class="user-photo" alt="UserAvatar" />
                </div>
                <div class="profile-info overflow-hidden">
                  <h6 class="font-weight-bold mb-0 text-dark text-truncate">{{ user()?.fname }} {{ user()?.lname }}</h6>
                  <p class="text-muted small mb-0 text-truncate">{{ roleName() }}</p>
                </div>
              </div>
            </li>

            <!-- Horizontal Controls (Language & Theme) -->
            <li class="p-2 border-bottom bg-light-soft">
              <div class="segmented-controls-wrapper d-flex flex-column gap-2">
                <!-- Theme Control -->
                <div class="segmented-control" role="group" aria-label="Theme Selection">
                  <button 
                    type="button" 
                    class="control-btn" 
                    [class.active]="themeMode() === 'light'"
                    (click)="setTheme('light'); $event.stopPropagation()"
                    title="Light Mode"
                  >
                    <i class="pi pi-sun"></i>
                  </button>
                  <button 
                    type="button" 
                    class="control-btn" 
                    [class.active]="themeMode() === 'dark'"
                    (click)="setTheme('dark'); $event.stopPropagation()"
                    title="Dark Mode"
                  >
                    <i class="pi pi-moon"></i>
                  </button>
                  <button 
                    type="button" 
                    class="control-btn" 
                    [class.active]="themeMode() === 'system'"
                    (click)="setTheme('system'); $event.stopPropagation()"
                    title="System Default"
                  >
                    <i class="pi pi-desktop"></i>
                  </button>
                </div>

                  <!-- Language Control -->
                  <div class="segmented-control mt-1" role="group" aria-label="Language Selection">
                    <button 
                      type="button" 
                      class="control-btn font-weight-bold" 
                      [class.active]="currentLanguage() === 'en'"
                      (click)="setLanguage('en'); $event.stopPropagation()"
                    >
                      EN
                    </button>
                    <button 
                      type="button" 
                      class="control-btn font-weight-bold" 
                      [class.active]="currentLanguage() === 'ta'"
                      (click)="setLanguage('ta'); $event.stopPropagation()"
                    >
                      TA
                    </button>
                    <button 
                      type="button" 
                      class="control-btn font-weight-bold" 
                      [class.active]="currentLanguage() === 'hi'"
                      (click)="setLanguage('hi'); $event.stopPropagation()"
                    >
                      HI
                    </button>
                  </div>

                  <!-- Font Size Control -->
                  <div class="segmented-control mt-1" role="group" aria-label="Font Size Selection">
                    <button 
                      type="button" 
                      class="control-btn" 
                      [class.active]="fontSize() === 'sm'"
                      (click)="setFontSize('sm'); $event.stopPropagation()"
                      title="Small Font"
                    >
                      <span style="font-size: 0.75rem;">A</span>
                    </button>
                    <button 
                      type="button" 
                      class="control-btn" 
                      [class.active]="fontSize() === 'md'"
                      (click)="setFontSize('md'); $event.stopPropagation()"
                      title="Medium Font"
                    >
                      <span style="font-size: 0.9rem;">A</span>
                    </button>
                    <button 
                      type="button" 
                      class="control-btn" 
                      [class.active]="fontSize() === 'lg'"
                      (click)="setFontSize('lg'); $event.stopPropagation()"
                      title="Large Font"
                    >
                      <span style="font-size: 1.1rem;">A</span>
                    </button>
                  </div>
                </div>
            </li>

            <!-- Main Actions -->
            <li class="menu-group-label px-3 pt-2 text-uppercase font-weight-bold text-muted small">{{ 'Main' | translate }}</li>
            <li role="none">
              <a href="javascript:void(0);" (click)="profilePage(); closeSubmenu()" class="dropdown-item" role="menuitem">
                <i class="pi pi-user mr-2"></i>{{ 'Profile' | translate }}
              </a>
            </li>
            <li role="none">
              <a href="javascript:void(0);" (click)="policyPage(); closeSubmenu()" class="dropdown-item" role="menuitem">
                <i class="pi pi-shield mr-2"></i>{{ 'Policies' | translate }}
              </a>
            </li>

            <!-- System -->
            <li class="menu-group-label px-3 pt-2 text-uppercase font-weight-bold text-muted small border-top mt-1">{{ 'System' | translate }}</li>
            <li *ngIf="emailListPermission()" role="none">
              <a href="javascript:void(0);" (click)="emailLogPage();closeSubmenu()" class="dropdown-item" role="menuitem">
                <i class="pi pi-envelope mr-2"></i>{{ 'Email Logs' | translate }}
              </a>
            </li>
            <li role="none">
              <a href="javascript:void(0);" (click)="openChangePassword(); closeSubmenu()" class="dropdown-item" role="menuitem">
                <i class="pi pi-cog mr-2"></i>{{ 'Settings' | translate }}
              </a>
            </li>

            <!-- Tools -->
            <li *ngIf="payrollPermission" class="menu-group-label px-3 pt-2 text-uppercase font-weight-bold text-muted small border-top mt-1">{{ 'Tools' | translate }}</li>
            <li *ngIf="payrollPermission" role="none">
              <a href="javascript:void(0);" (click)="calSI(SITEMP); closeSubmenu()" class="dropdown-item" role="menuitem">
                <i class="pi pi-calculator mr-2"></i>{{ 'SI Calculator' | translate }}
              </a>
            </li>

            <!-- Logout -->
            <li class="border-top mt-1" role="none">
              <a href="javascript:void(0);" (click)="logout(); closeSubmenu()" class="dropdown-item text-danger font-weight-bold" role="menuitem">
                <i class="pi pi-power-off mr-2"></i>{{ 'Logout' | translate }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <div class="progress-container">
    <div class="progress-bar" id="myBar"></div>
  </div>
</nav>

<ng-template #SITEMP>
  <div class="modal-header">
    <h6 class="mb-0 modal-title">{{ "SI Calculation" | translate | titlecase }}</h6>
    <button type="button" class="close text-right" (click)="close(SITEMP)">
      <span>X</span>
    </button>
  </div>
  <div class="card">
    <div class="body">
      <app-form-generator #formGen [formData]="formDate" />
      <button
        type="button"
        class="btn btn-round btn-primary"
        (click)="calculateYearOfExpPayroll(formGen?.getFormValue())"
      >
        {{ 'Calculate' | translate }}
      </button>
      <div *ngIf="yearOfExpPayroll !== null">
        <p class="mt-3">
          <strong>{{ 'Year of Experience (Payroll):' | translate }}</strong>
          {{ yearOfExpPayroll }} {{ 'years' | translate }}
        </p>
      </div>
    </div>
  </div>
</ng-template>
